import * as Yup from 'yup'
import { REGEXS } from 'utils'

const amountValidation = REGEXS.amountRegex
const schema = Yup.object().shape({
  OrganizationId: Yup.string().required('Organizations is required'),
  CustomerOwned: Yup.boolean().required('Customer Owned is required'),
  Notes: Yup.string(),
  HardwareType: Yup.string().required('Hardware Type is required'),
  ManufacturerName: Yup.string().required('Manufacturer Name is required'),
  DeviceUUID: Yup.string().required('Device UUID is required'),
  DeviceName: Yup.string().required('Device Name is required'),
  CardReaderSerialNumber: Yup.string().required(
    'Card Reader Serial Number is required',
  ),
  CardReaderFirmwareVersion: Yup.string().required(
    'Card Reader Firmware Version is required',
  ),
  CardReaderType: Yup.string().required('Card Reader Type is required'),
  OperatingSystemVersion: Yup.string().required(
    'Operating System Version is required',
  ),
  ExtensiaAppVersion: Yup.string().required('Extensia App Version is required'),
  BluetoothCode: Yup.string(),
  UseCustomAmount: Yup.boolean().required('Customer Owned is required'),
  CustomAmount: Yup.string()
    .required('Amount is required')
    .matches(amountValidation, 'Invalid cost'),
  MDMDeviceName: Yup.string(),
  DeploymentDate: Yup.date()
    .typeError('Invalid Date')
    .required('Deployment Date is required'),
  DeviceLocation: Yup.string(),
})

const hardwareValidation = {
  async validator({ field }, value) {
    await schema.validateSyncAt(field, { [field]: value })
  },
}

export { hardwareValidation }
